import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummaryBlock from './components/AccordionSummaryBlock';
import Details from './components/Details';
import utils from 'components/utils';
import moment from 'moment';

const Refused = props => {
	const theme = useTheme();
	const iCan = utils.usePermissions();
	const translate = utils.useI18N();
	const loadingWishlists = useStoreState(state => state.wishlistSpecial.loadingWishlists);
	const loadRefused = useStoreActions(dispatch => dispatch.wishlistSpecial.loadRefused);
	const refused = useStoreState(state => state.wishlistSpecial.refused);
	const expandedRefused = useStoreState(state => state.wishlistSpecial.expandedRefused);
	const setExpandedRefused = useStoreActions(dispatch => dispatch.wishlistSpecial.setExpandedRefused);
	const filters = useStoreState(state => state.wishlistSpecial.filters);
	const [wishlistView, setWishlistView] = useState(refused);

	const handleChange = (index, id) => (event, isExpanded) => {
		setExpandedRefused(isExpanded ? { index: index, id: id } : { index: -1, id: -1 });
	};

	const getLabelDepot = item => {
		if (item.wishlistItems && item.wishlistItems.length > 0)
			return ' (' + item.wishlistItems[0].depotDescription + ')';
		else return '';
	};

	const getLabelDate = item => {
		const label =
			item.type === 'ADOZIONE'
				? translate('wishlistSpecial.typeAdozione')
				: item.type === 'FESTIVAL'
				? translate('wishlistSpecial.typeFestival')
				: item.type === 'PRESENTAZIONE'
				? translate('wishlistSpecial.typePresentazione')
				: '';
		return translate('wishlistSpecial.date') + ' ' + label;
	};

	useEffect(() => {
		loadRefused();

		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}, []);

	useEffect(() => {
		let wlFiltered = refused;
		if (filters.token.length > 0) wlFiltered = refused.filter(i => i.userCode.includes(filters.token));
		if (filters.types.length > 0) wlFiltered = wlFiltered.filter(i => filters.types.includes(i.type));
		if (filters.depots.length > 0)
			wlFiltered = wlFiltered.filter(i => i.wishlistItems.some(item => filters.depots.includes(item.depotCode)));

		setWishlistView(wlFiltered);
	}, [filters, refused]);

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0}
			sx={{ width: '100%' }}
		>
			{!loadingWishlists && wishlistView.length === 0 && (
				<Stack
					direction="column"
					justifyContent="center"
					alignItems="center"
					spacing={1}
					sx={{ width: '100%', margin: '20px auto !important' }}
				>
					<Typography variant="titleSection">{translate('wishlistSpecial.noResults')}</Typography>
				</Stack>
			)}
			{!loadingWishlists && wishlistView.length > 0 && (
				<Stack
					direction="column"
					justifyContent="flex-start"
					alignItems="flex-start"
					spacing={0}
					sx={{ width: '100%', marginTop: '20px' }}
				>
					{wishlistView.map((item, index) => (
						<Accordion
							key={index}
							expanded={expandedRefused.index === index}
							onChange={handleChange(index, item.id)}
							sx={{
								marginBottom: '15px',
								width: '100%'
							}}
						>
							<AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel-header">
								<Stack
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									spacing={1}
									sx={{ width: '100%' }}
								>
									<AccordionSummaryBlock
										label1=""
										label1bold={false}
										value1={item.userCodeName + ' (' + item.userCode + ')'}
										value1bold={true}
										label2="Ag."
										label2bold={true}
										value2={item.createdByName}
										value2bold={false}
										sx={{
											width: '35%',
											display: { xs: 'none', md: 'inherit', sm: 'inherit' }
										}}
									/>
									<AccordionSummaryBlock
										label1=""
										value1={item.name.toUpperCase()}
										value1bold={true}
										label2={getLabelDate(item)}
										label2bold={true}
										value2={item.eventDate ? moment(item.eventDate).format('L') : ''}
										sx={{ width: { xs: '50%', md: '40%', sm: '40%' } }}
									/>
									<AccordionSummaryBlock
										label1={translate('wishlist.summary.quantity')}
										label1bold={true}
										value1={item.totalItems + getLabelDepot(item)}
										label2={translate('wishlist.summary.totalValue')}
										label2bold={true}
										value2={utils.formatPrice(item.totalPrice)}
										sx={{ width: { xs: '50%', md: '25%', sm: '25%' } }}
									/>
								</Stack>
							</AccordionSummary>
							<AccordionDetails>
								{expandedRefused.index === index && (
									<Details
										wishlistId={item.id}
										whislistName={item.name}
										wishlistType={item.type}
										expanded={expandedRefused}
										viewAction={false}
									/>
								)}
							</AccordionDetails>
						</Accordion>
					))}
				</Stack>
			)}
		</Stack>
	);
};

export default Refused;
